import React from 'react';
import { motion } from 'framer-motion';
import { Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import PerButton from './PerButton';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { M_PER_CUSTOM_01_Schema } from '../M_PER_CUSTOM_01/M_PER_CUSTOM_01_Schema';
import { PermitActions } from '../../../../Reducer/PermitReducer';

export default function WriteCheckListCommon({
  title,
  codeListKey,
  onNext,
  onPrev,
}) {
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const { baseInfo, codeInfo } = useSelector((state) => state.permit);

  const schema = M_PER_CUSTOM_01_Schema.fields.codeInfo[codeListKey];
  const { nameKey, codeKey } = schema;

  const workTypeName =
    codeInfo?.workTypes?.find((item) => item.workType === baseInfo.workType)
      ?.workTypeNm || '';

  const handleToggle = (code) => {
    const currentList = codeInfo[codeListKey] || [];
    const updatedList = currentList.map((item) =>
      item[codeKey] === code
        ? { ...item, itemCheck: item.itemCheck === 'Y' ? '' : 'Y' }
        : item
    );

    dispatch(PermitActions.setCodeInfo({ [codeListKey]: updatedList }));
  };

  const getCardStyle = (checked) => ({
    cursor: 'pointer',
    borderRadius: '12px',
    backgroundColor: checked ? '#fbfafdff' : '#FFFFFF',
    border: `1.5px solid ${checked ? '#5c6cfaff' : '#E0E0E0'}`,
    padding: '14px 18px',
    marginBottom: '10px',
    boxShadow: checked
      ? '0 3px 8px rgba(153, 151, 158, 0.25)'
      : '0 1px 4px rgba(0,0,0,0.05)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    transition: 'all 0.25s ease',
  });

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
    >
      <p>
        <span style={{ color: '#eb6c1dff' }}>{workTypeName}허가서</span> {title}
        을(를) 선택해주세요.
      </p>

      <p style={{ fontSize: '16px', color: '#939393' }}>
        해당되는 항목은 선택(✔)해주세요.
      </p>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
          marginTop: '8px',
          marginBottom: '16px',
        }}
      >
        <Typography sx={{ fontWeight: 'bold', fontSize: '18px', mb: 1 }}>
          {title}
        </Typography>

        {codeInfo[codeListKey] && codeInfo[codeListKey].length > 0 ? (
          codeInfo[codeListKey].map((item) => {
            const checked = item.itemCheck === 'Y';
            return (
              <motion.div
                key={item[codeKey]}
                whileTap={{ scale: 0.97 }}
                transition={{ duration: 0.1 }}
                style={getCardStyle(checked)}
                onClick={() => handleToggle(item[codeKey])}
              >
                <Typography
                  sx={{
                    fontWeight: 'bold',
                    fontSize: '16px',
                    color: checked ? '#4f7cf7ff' : '#858383ff',
                  }}
                >
                  {item[nameKey]}
                </Typography>
                {checked ? (
                  <CheckCircleIcon
                    sx={{ color: '#3d60faff', fontSize: '26px' }}
                  />
                ) : (
                  <RadioButtonUncheckedIcon
                    sx={{ color: '#C7C7C7', fontSize: '24px' }}
                  />
                )}
              </motion.div>
            );
          })
        ) : (
          <Typography sx={{ color: '#A0A0A0', mt: 2, textAlign: 'center' }}>
            {title} 항목이 없습니다.
          </Typography>
        )}
      </div>

      <PerButton
        cancelText="이전"
        onCancel={() => {
          onPrev
            ? onPrev()
            : dispatch(CommonActions.setActiveStep(activeStep - 1));
        }}
        onClick={() => {
          onNext ? onNext() : dispatch(CommonActions.increaseStep());
        }}
      />
    </motion.div>
  );
}
